import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/profile",
    children: [
      {
        name: "profile",
        path: "",
        component: () => import("../presentation/pages/Profile.vue"),
        meta: {
          layout: "default",
          public: false,
        },
      },
      {
        name: "profile-notifications",
        path: "notifications",
        component: () => import("../presentation/pages/Notifications.vue"),
        meta: {
          layout: "default",
          public: false,
        },
      },
    ],
  },
];
